import LetrusLogo from 'assets/images/icons/letrus-logo.webp';
import FirstSlideImage from 'assets/images/write-preparation/writing-preparation-modal-1.webp';
import SecondSlideImage from 'assets/images/write-preparation/writing-preparation-modal-2.webp';
import ThirdSlideImage from 'assets/images/write-preparation/writing-preparation-modal-3.webp';
import {useRef, useState} from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import {Button, Modal} from 'letrus-ui';
import styles from './FirstAccessModal.module.scss';

export interface FirstAccessModalProps {
  id: string;
  onCloseModal(): void;
}

function FirstAccessModal({
  id,
  onCloseModal,
}: FirstAccessModalProps): JSX.Element {
  const [currentSlide, setCurrentSlide] = useState(0);
  const sliderRef = useRef<Slider>(null);

  const slide1ref = useRef<HTMLDivElement>(null);
  const slide2ref = useRef<HTMLDivElement>(null);
  const slide3ref = useRef<HTMLDivElement>(null);
  const slideRefs = [slide1ref, slide2ref, slide3ref];

  function advanceSlide() {
    if (sliderRef.current) {
      if (currentSlide === 2) {
        onCloseModal();
      } else {
        sliderRef.current.slickNext();
      }
    }
  }

  return (
    <Modal id={id} className={styles.wrapper} childClassName={styles.content}>
      <img src={LetrusLogo} className={styles.logo} alt="Letrus" aria-hidden />

      <div className={styles.sliderWrapper}>
        <Slider
          infinite={false}
          slidesToShow={1}
          slidesToScroll={1}
          initialSlide={0}
          arrows={false}
          className={styles.slider}
          variableWidth={false}
          ref={sliderRef}
          afterChange={(slide) => {
            setCurrentSlide(slide);
            slideRefs[slide].current?.focus();
          }}
        >
          <div id="slide-1" className={styles.slide} ref={slide1ref}>
            <img src={FirstSlideImage} alt="lista de marcações" aria-hidden />
            <h1>Trazemos boas novas!</h1>
            <p>
              Pensando no seu desenvolvimento, trouxemos uma nova forma para
              você se <b>preparar para escrita.</b>
            </p>
          </div>

          <div id="slide-2" className={styles.slide} ref={slide2ref}>
            <img src={SecondSlideImage} alt="card de anotação" aria-hidden />
            <h1>E não acaba por aí!</h1>
            <p>
              Agora você pode <b>anotar tudo que precisa</b> enquanto você lê os
              textos motivadores e tudo isso estará disponível na{' '}
              <b>hora da escrita</b>.
            </p>
          </div>

          <div id="slide-3" className={styles.slide} ref={slide3ref}>
            <img src={ThirdSlideImage} alt="lista de atividades" aria-hidden />
            <h1>Vamos grifar?</h1>
            <p>
              Que tal <b>grifar as partes que você acha mais importantes</b> no
              texto? Isso também estará disponível na escrita.
            </p>
          </div>
        </Slider>
      </div>

      <Button variant="primary" onClick={() => advanceSlide()}>
        Continuar
      </Button>
    </Modal>
  );
}

export default FirstAccessModal;
